// Escape de HTML puro. Sin dependencias del DOM ni de Supabase: funciona
// igual en los paneles (navegador) y en tests (Node), y evita Stored XSS
// cuando se interpola contenido controlado por tenants/usuarios dentro de
// plantillas con innerHTML.

const MAPA_ESCAPE = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

function normalizar(valor) {
  if (valor === null || valor === undefined) return '';
  return String(valor);
}

/**
 * Escapa los 5 caracteres HTML peligrosos para interpolación en markup.
 *
 * @param {unknown} valor Valor a escapar (se convierte a string).
 * @returns {string} cadena segura para insertar en HTML.
 */
export function escaparHtml(valor) {
  return normalizar(valor).replace(/[&<>"']/g, (caracter) => MAPA_ESCAPE[caracter] ?? caracter);
}

/**
 * Escapa para contexto de atributo HTML (comillas dobles + ampersand + < >).
 * Escapa también la comilla simple por defensa.
 *
 * @param {unknown} valor Valor a escapar (se convierte a string).
 * @returns {string} cadena segura dentro de atributos delimitados por comillas.
 */
export function escapeAttr(valor) {
  return escaparHtml(valor);
}
